//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCard from '~/components/Dashboard/Cards/BaseCard.vue'
import InfoCard from '~/components/Dashboard/Cards/InfoCard.vue'
import ActionCard from '~/components/Dashboard/Cards/ActionCard.vue'
import ImageCard from '~/components/Dashboard/Cards/ImageCard.vue'

export default {
  components: {
    BaseCard,
    InfoCard,
    ActionCard,
    ImageCard,
  },
  methods: {
    handleClick() {
      this.$router.push(`/experiencias`)
    },
  },
}
